import _get from 'lodash/get';
import _set from 'lodash/set';
import _trim from 'lodash/trim';

import { INCENTIVE_TYPE } from 'dictionary';

export function validate(data) {
  const errors = {};

  const type = _trim(_get(data, 'discount_type', ''));
  const value = _trim(_get(data, 'incentive_amount', ''));
  const threshold = _trim(_get(data, 'ceiling_incentive_amount', ''));
  const isPercent = type === INCENTIVE_TYPE.PERCENT;

  if (!value) {
    _set(errors, 'value', 'Required');
  } else if (+value < 0) {
    _set(errors, 'value', 'Must be greater than or equal to 0');
  } else if (isPercent && +value === 0) {
    _set(errors, 'value', 'Must be greater than 0');
  } else if (isPercent && +value > 100) {
    _set(errors, 'value', 'Must be less than 100');
  }
  if (!threshold) {
    _set(errors, 'threshold', 'Required');
  } else if (+threshold < 0) {
    _set(errors, 'threshold', 'Must be greater than or equal to 0');
  } else if (isPercent && +threshold === 0) {
    _set(errors, 'threshold', 'Must be greater than 0');
  }

  return errors;
}
